import { render } from "./MyListsSidebarElement.vue?vue&type=template&id=5b54fc9c&scoped=true"
import script from "./MyListsSidebarElement.vue?vue&type=script&lang=js"
export * from "./MyListsSidebarElement.vue?vue&type=script&lang=js"

import "./MyListsSidebarElement.vue?vue&type=style&index=0&id=5b54fc9c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/components/elements/my-lists/my-lists-sidebar-element.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fmy-lists%2FMyListsSidebarElement.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b54fc9c"]])

export default __exports__